import React, { useState } from "react";
import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { MAIN_URL } from "../../constants";
import axios from "axios";
import { toast } from "react-toastify";
import { GripVertical, Pencil, Trash2 } from "lucide-react";
import { Button, Modal } from "../../Components/ui";
import CourseThumbnail from "../../Components/Courses/CourseThumbnail";

const SortableLesson = ({ lesson, index, handleLessonClick, chapterId }) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: lesson.id });
    const [deletedIsOpen, setDeletedIsopen] = useState(false)
    const [lessonId, setLessonId] = useState(0)
    const TOKEN = localStorage.getItem('admin_token')
    // dnd-kit pozitsiyasi (transform/transition) — ko'rinish CSS'da (.ui-lesson)
    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
    };
    const isOpenDelete = () => {
        setDeletedIsopen(x=>!x)
    }

    const deletedLesson = () => {
        axios.delete(`${MAIN_URL}/courses/lessons/${lessonId}`, {
            headers: {
                "Content-type": "application/json",
                Authorization: `Bearer ${TOKEN}`
            },
        }).then((res) => {
            setDeletedIsopen(false)
            toast.success('Deleted')
            window.location.reload()
        }).catch((err) => console.log(err))
    }

    return (
        <div ref={setNodeRef} style={style} className={`ui-lesson ${isDragging ? "ui-lesson--dragging" : ""}`}>
            <span {...attributes} {...listeners} className="ui-lesson__handle" aria-label="Darsni sudrash">
                <GripVertical aria-hidden="true" />
            </span>
            <span className="ui-lesson__order">{lesson?.order}</span>
            <div className="ui-lesson__main" onClick={(e) => { e.stopPropagation(); handleLessonClick(lesson.id, chapterId); }}>
                <CourseThumbnail src={lesson.photo ? `${MAIN_URL}/${lesson.photo}` : null} className="ui-lesson__thumb" />
                <div className="ui-lesson__text">
                    <span className="ui-lesson__title">{lesson.title}</span>
                    <div className="ui-lesson__desc" dangerouslySetInnerHTML={{ __html: lesson.description }}></div>
                </div>
            </div>
            <Button
                variant="ghost"
                size="sm"
                iconOnly
                aria-label="Darsni tahrirlash"
                onClick={(e) => { e.stopPropagation(); handleLessonClick(lesson.id, chapterId); }}
            >
                <Pencil />
            </Button>
            <Button
                variant="ghost"
                size="sm"
                iconOnly
                aria-label="Darsni o'chirish"
                className="ui-edit-course__danger-icon"
                onClick={() => {isOpenDelete(); setLessonId(lesson.id)}}
            >
                <Trash2 />
            </Button>
            <Modal
                open={deletedIsOpen}
                onClose={isOpenDelete}
                title="Darsni o'chirasizmi?"
                size="sm"
                footer={
                    <>
                        <Button variant="secondary" onClick={isOpenDelete}>Bekor qilish</Button>
                        <Button variant="danger-solid" leftIcon={<Trash2 />} onClick={deletedLesson}>O'chirish</Button>
                    </>
                }
            >
                <p className="ui-edit-course__modal-name">{lesson.title}</p>
                <p className="ui-edit-course__modal-text">Bu amalni ortga qaytarib bo'lmaydi.</p>
            </Modal>
        </div>
    );
};

export default SortableLesson;
